import type { IconProps as BootstrapIconProps } from 'react-bootstrap-icons';
import * as icons from 'react-bootstrap-icons';

interface IconProps extends BootstrapIconProps {
  iconName: keyof typeof icons;
}

export function Icon({ iconName, ...props }: IconProps) {
  const BootstrapIcon = icons[iconName];
  return <BootstrapIcon {...props} />;
}
